import { useGetHTMLPageQuery } from "htmlpage/api/html-page.api";
import { useParams } from "react-router-dom";

import { HtmlPageAdminForm } from "../components/forms/HTMLPageAdminForm";

import QueryWrapper from "common/components/QueryWrapper";

export function HtmlPageAdminView({ isCreateMode }: { isCreateMode: boolean }) {
  const { htmlPageId } = useParams<{ htmlPageId: string }>();

  const query = useGetHTMLPageQuery(htmlPageId!, {
    skip: !htmlPageId,
  });

  return (
    <>
      {htmlPageId ? (
        <QueryWrapper query={query}>
          {(htmlPage) => (
            <HtmlPageAdminForm htmlPage={htmlPage} editMode={true} />
          )}
        </QueryWrapper>
      ) : (
        <HtmlPageAdminForm editMode={false} />
      )}
    </>
  );
}
